import { useQuery } from "@tanstack/react-query"
import { useORPC } from "@/providers/orpc-provider"

export const useUserCoupons = (
	status: string[],
	page: number = 1,
	pageSize: number = 10,
) => {
	const orpc = useORPC()

	return useQuery({
		...orpc.ec.userCoupon.findMyCoupons.queryOptions({
			input: { status, page, pageSize },
		}),
	})
}

export const useUserCouponsByProductAndChannel = (
	productInfo: Array<{
		skuId: string
		spuId: string
		quantity: number
		price: number
		total: number
	}>,
	platformChannels: string,
	salesChannels?: string,
	options?: { enabled?: boolean },
) => {
	const orpc = useORPC()

	return useQuery({
		...orpc.ec.userCoupon.getUserCouponListByProductAndChannel.queryOptions({
			input: { productInfo, platformChannels, salesChannels },
		}),
		enabled: options?.enabled ?? true,
		staleTime: 0,
	})
}
